export const SearchIcon = (props: React.ComponentPropsWithoutRef<"svg">) => {
	return (
		<svg viewBox="0 0 21 21" {...props}>
			<use href="/images/icons.svg#vlw-search" />
		</svg>
	)
}
